// frontend/src/utils/bookingTimeUtils.js

export const MAX_ADDRESS_LENGTH = 45;

/**
 * Normalize time inputs like "HH:MM" or "HH:MM:SS" into "HH:MM:SS".
 * Returns null when the value cannot be converted into a valid time.
 */
export const normalizeBookingTime = (timeValue) => {
  if (!timeValue || typeof timeValue !== 'string') return null;

  const trimmedValue = timeValue.trim();
  if (!trimmedValue) return null;

  const candidate = trimmedValue.split('-')[0].trim();
  const match = candidate.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?\s*(AM|PM|am|pm)?$/);

  if (!match) return null;

  const hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  const seconds = match[3] ? parseInt(match[3], 10) : 0;
  const meridiem = match[4]?.toLowerCase() || null;

  if ([hours, minutes, seconds].some(Number.isNaN) || hours > 23 || minutes > 59 || seconds > 59) {
    return null;
  }

  let normalizedHours = hours;
  if (meridiem) {
    if (hours < 1 || hours > 12) return null;
    if (meridiem === 'am') {
      normalizedHours = hours === 12 ? 0 : hours;
    } else {
      normalizedHours = hours === 12 ? 12 : hours + 12;
    }
  }

  const pad = (value) => value.toString().padStart(2, '0');
  return `${pad(normalizedHours)}:${pad(minutes)}:${pad(seconds)}`;
};

/**
 * Trim long addresses for list displays. Keeps the first two comma-separated
 * segments when possible before appending an ellipsis.
 */
export const shortenAddress = (address, maxLength = MAX_ADDRESS_LENGTH) => {
  if (!address) return '';

  if (address.length <= maxLength) return address;

  const parts = address.split(',');
  const firstPart = (parts[0] || '').trim();
  const secondPart = (parts[1] || '').trim();
  const combined = secondPart ? `${firstPart}, ${secondPart}` : firstPart;

  if (combined.length >= maxLength - 3) {
    return `${combined.substring(0, maxLength - 3)}...`;
  }

  return `${combined}, ...`;
};
